<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_bc7" :custom="{storage: true}" export :refresh="{query: findList}">
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      class="mytable-style"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.authStatusExt" placeholder="请选择" clearable>
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="authTime" min-width="360" title="审核时间" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="authTimeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'authTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="licenseNumber" title="车牌号" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.licenseNumber" placeholder="请输入车牌号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseColor"
          title="车牌颜色"
          :formatter="formatterCehicleLicenseColor"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.vehicleLicenseColor" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.vehicleLicenseColorList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="vehicleLicense" title="车辆行驶证档案编号" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.vehicleLicense" placeholder="请输入车辆行驶证档案编号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="classificationCode"
          title="车辆分类"
          :formatter="formatterVehicleClassification"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.classificationCode" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="vehicleLicenseDueDate" title="车辆行驶证到期日期" min-width="360" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="vehicleLicenseDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'vehicleLicenseDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="roadTransportCertificateDate" title="道路运输证到期日期" min-width="360" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="roadTransportCertificateDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'roadTransportCertificateDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="创建时间" min-width="360" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="owner" title="车主姓名" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.owner" placeholder="请输入车主姓名" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="realOwnerPhone" title="车主电话" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.realOwnerPhone" placeholder="请输入车主电话" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="roadTransportCertificateNumber" title="道路运输证号" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.roadTransportCertificateNumber" placeholder="请输入车辆道路运输证号" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleEnergyType"
          title="能源类型"
          :formatter="formatterVehicleEnergyType"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.vehicleEnergyType" placeholder="请选择" clearable>
            <el-option
              v-for="item in parentData.vehicleEnergyTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="totalWeight" title="总质量/挂车车头整备质量(Kg)" min-width="240" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.totalWeightStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.totalWeightEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="loadWeight" title="核定载质量/准牵引总质量(Kg)" min-width="240" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.loadWeightStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.loadWeightEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isHasTrailer"
          title="是否挂车"
          :formatter="formatterHasTrailer"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.isHasTrailer" placeholder="请选择" clearable>
            <el-option
              v-for="item in isHasTrailers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="trailerNum" title="挂车车牌号" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.trailerNum" placeholder="请输入挂车车牌号" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" fixed="right" min-width="100">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.authStatusExt != 3"
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code,'review')">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelDetailFlag" :title="modelTtile" width="1200" height="800" resize>
      <compDetail ref="detailRef" :parent-data="parentData" @fatherMethods="fatherMethods" />
    </vxe-modal>
  </div>
</template>
<script>
	import compDetail from "./components/vehicleDetail.vue";
	import {
		rainbowVehicleList
	} from "@/api/driver";
	import {
		getListDict
	} from "@/api/commonApi";
	export default {
		name: "TeamVehicleReview",
		components: {
			compDetail
		},
		data() {
			return {
				loading: false,
				tableData: [],
				modelDetailFlag: false,
				vehicleReviewFlag: false,
				datagramFlag: false,
				modelTtile: '详情',
				vehicleLicenseDueDateRange: [],
				roadTransportCertificateDateRange: [],
				authTimeRange: [],
				listQuery: {
					pageNum: 1,
					pageSize: 20,
					total: 0
				},
				Pagingconf: [],
				gmtCreatedRange: "",
				vehicleLengthList: [],
				vehicleWidthList: [],
				vehicleHighList: [],
				vehicleTonnageList: [],
				parentData: {
					model: 'detail',
					isDetail: true,
					vehicleClassificationList: [],
					vehicleEnergyTypeList: [],
					locationSourceList: [],
					vehicleLicenseColorList: [],
				},
				// 审核状态
				authStatusOptions: [{
						label: "未审核",
						value: 0
					},
					// { label: "审核中", value: 1 },
					{
						label: "审核未通过",
						value: 2
					},
					{
						label: "审核通过",
						value: 3
					}
				],
				// 是否挂车
				isHasTrailers: [{
						label: "否",
						value: 0
					},
					{
						label: "是",
						value: 1
					}
				],
				// 车辆属性
				vehicleAttributeOptions: [{
						label: "外协",
						value: 0
					},
					{
						label: "自有",
						value: 1
					}
				],
				loginkTarget: 0,
				groupLevel: 0,
			};
		},
		computed: {
			model() {
				return this.parentData.model
			}
		},
		watch: {
			model(val) {
				this.modelTtile = val === 'review' ? '审核' : '详情'
			}
		},
		created() {
			// 获取数据字典： 车型，车长，车宽，车高，吨位，定位来源，车牌颜色
			getListDict({
				types: "vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleLicenseColor,vehicleEnergyType"
			}).then(response => {
				this.parentData.vehicleClassificationList = response.data.filter(
					item => item.type === "vehicleClassification"
				)[0]["dictList"];
				this.vehicleTonnageList = response.data.filter(
					item => item.type === "vehicleTonnage"
				)[0]["dictList"];
				this.parentData.locationSourceList = response.data.filter(
					item => item.type === "locationSource"
				)[0]["dictList"];
				this.parentData.vehicleLicenseColorList = response.data.filter(
					item => item.type === "vehicleLicenseColor"
				)[0]["dictList"];
				this.parentData.vehicleEnergyTypeList = response.data.filter(
					item => item.type === "vehicleEnergyType"
				)[0]["dictList"];
				let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
				this.loginkTarget =
					dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince ? dataBranch
					.partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue : 0
				this.findList();
			});
		},
		methods: {
			// 设置重量小数点后三位
			setkey(value, key) {
				this.$set(this.listQuery, key, value.replace(/\.[0-9]+/, ''))
			},
			findList() {
				this.loading = true;
				return new Promise(resolve => {
					rainbowVehicleList(this.listQuery).then(response => {
						this.tableData = response.data.records;
						this.listQuery.total = response.data.total;
						response.data.total > 10000 ? this.Pagingconf = [20, 30, 50, 100, 10000] : this
							.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
						this.loading = false;
						resolve();
					});
				});
			},

			// 详情方法
			funcDetail(code, prefix) {
				this.$refs.detailRef.getInfo(code);
				this.modelDetailFlag = true;
				this.$set(this.parentData, "model", prefix);
			},
			fatherMethods() {
				this.vehicleReviewFlag = !this.vehicleReviewFlag;
				this.modelDetailFlag = false;
				this.findList();
			},
			// 查询
			funcFilter() {
				this.listQuery.pageNum = 1;
				this.findList();
			},
			// 排序
			sortList({
				column,
				property,
				order
			}) {
				if (order) {
					this.listQuery.sortField = property;
					this.listQuery.sortType = order;
				} else {
					this.listQuery.sortField = "";
				}
				this.findList();
			},
			// 时间
			changeDate(value, prefix) {
				if (value) {
					this.listQuery[`${prefix}Start`] = value[0] + " 00:00:00";
					this.listQuery[`${prefix}End`] = value[1] + " 23:59:59";
				} else {
					this.listQuery[`${prefix}Start`] = "";
					this.listQuery[`${prefix}End`] = "";
				}
			},
			// 翻译审核状态
			formatterAuthStatus({
				cellValue
			}) {
				const item = this.authStatusOptions.find(
					item => item.value === cellValue
				);
				return item ? item.label : "";
			},
			// 翻译车型
			formatterVehicleClassification({
				cellValue
			}) {
				const item = this.parentData.vehicleClassificationList.find(
					item => item.code === cellValue
				);
				return item ? item.name : "";
			},
			// 翻译车牌颜色
			formatterCehicleLicenseColor({
				cellValue
			}) {
				const item = this.parentData.vehicleLicenseColorList.find(
					item => item.code === cellValue
				);
				return item ? item.name : "";
			},
			// 翻译定位来源
			formatterLocationSource({
				cellValue
			}) {
				const item = this.parentData.locationSourceList.find(item => item.code == cellValue);
				return item ? item.name : "";
			},
			formatterVehicleAttribute({
				cellValue
			}) {
				const item = this.vehicleAttributeOptions.find(item => item.value === cellValue);
				return item ? item.label : "";
			},
			formatterHasTrailer({
				cellValue
			}) {
				const item = this.isHasTrailers.find(item => item.value === cellValue);
				return item ? item.label : "";
			},
			//打印
			Printing(code, licenseNumber) {
				this.$refs.dayinRef.getInfo(code, licenseNumber);
				this.Printingxianyin = true;
			},
			// 翻译能源类型
			formatterVehicleEnergyType({
				cellValue
			}) {
				const item = this.parentData.vehicleEnergyTypeList.find(
					item => item.code === cellValue
				);
				return item ? item.name : "";
			},
			// 公共取消
			fatherCancel(modelFlag) {
				switch (modelFlag) {
					case "add":
						this.modelAddFlag = false;
						break;
					case "edit":
						this.modelEditFlag = false;
						break;
					case "detail":
						this.modelDetailFlag = false;
						break;
					default:
				}
			},
			// 分页handle
			handlePageChange({
				currentPage,
				pageSize
			}) {
				this.listQuery.pageNum = currentPage;
				this.listQuery.pageSize = pageSize;
				this.findList();
			},
		}
	};
</script>
<style scoped>
	.mytable-style .vxe-body--column.col-red {
		background-color: red;
		color: #fff;
	}
</style>
